import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'timezoneDate'
})

export class TimezoneDatePipe implements PipeTransform {

	transform(value, ...args: unknown[]) {
		return new Date( new Date(value).getTime() - ( -1 * 60 * 1000 * new Date(value).getTimezoneOffset()));
	}

}
